import React from 'react';

const MethodStepsV2 = () => {
  const steps = [
    {
      number: "01",
      title: "Entender",
      description: "Mapeamos objetivo, horizonte, fluxo de caixa, liquidez e restrições."
    },
    {
      number: "02",
      title: "Comparar",
      description: "Colocamos alternativas e custos na mesma linguagem, com premissas explícitas."
    },
    {
      number: "03",
      title: "Desenhar",
      description: "Estruturamos um projeto compatível com o que foi confirmado no diagnóstico."
    },
    {
      number: "04",
      title: "Documentar",
      description: "Registramos premissas, riscos, responsabilidades e próximos passos antes da contratação."
    },
    {
      number: "05",
      title: "Revisar",
      description: "[CONFIRMAR: descrever acompanhamento contratado, periodicidade e limites]"
    }
  ];

  return (
    <section id="metodo" className="py-16 md:py-24 bg-background">
      <div className="container px-4 md:px-6 mx-auto max-w-5xl">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold tracking-tight md:text-4xl mb-4">
            Um processo simples para uma decisão que não é simples.
          </h2>
        </div>

        <div className="grid gap-8 md:grid-cols-5 relative">
          <div className="hidden md:block absolute top-1/2 left-0 w-full h-0.5 bg-muted -translate-y-1/2 z-0" />
          
          {steps.map((step, index) => (
            <div key={index} className="relative z-10 flex flex-col items-center text-center">
              <div className="w-12 h-12 rounded-full bg-primary text-primary-foreground flex items-center justify-center text-xl font-bold mb-4 shadow-lg ring-4 ring-background">
                {step.number}
              </div>
              <h3 className="text-lg font-semibold mb-2">{step.title}</h3>
              <p className="text-sm text-muted-foreground leading-relaxed">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MethodStepsV2;
